import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ComplianceReports from './pages/compliance-reports';
import VoyagePlanning from './pages/voyage-planning';
import UserManagement from './pages/user-management';
import EmissionsCalculator from './pages/emissions-calculator';
import EUATradingHub from './pages/eua-trading-hub';
import VesselPerformance from './pages/vessel-performance';
import FleetDashboard from './pages/fleet-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ComplianceReports />} />
        <Route path="/compliance-reports" element={<ComplianceReports />} />
        <Route path="/voyage-planning" element={<VoyagePlanning />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/emissions-calculator" element={<EmissionsCalculator />} />
        <Route path="/eua-trading-hub" element={<EUATradingHub />} />
        <Route path="/vessel-performance" element={<VesselPerformance />} />
        <Route path="/fleet-dashboard" element={<FleetDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
